/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  SmartProblemDetails,
  TermsOfUseFileResponse,
  TermsOfUseResponse,
} from '../models/index';
import {
    SmartProblemDetailsFromJSON,
    SmartProblemDetailsToJSON,
    TermsOfUseFileResponseFromJSON,
    TermsOfUseFileResponseToJSON,
    TermsOfUseResponseFromJSON,
    TermsOfUseResponseToJSON,
} from '../models/index';

export interface DeleteTermsOfUseFileRequest {
    termsOfUseId: string;
}

export interface TermsOfUseGetByIdRequest {
    termsOfUseId: string;
}

export interface UploadTermsOfUsePostRequest {
    uploadedFile?: Blob;
}

/**
 * 
 */
export class TermsOfUseApi extends runtime.BaseAPI {

    /**
     */
    async acceptCurrentTermsOfUsePatchRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/TermsOfUse/Accept`;

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async acceptCurrentTermsOfUsePatch(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.acceptCurrentTermsOfUsePatchRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteTermsOfUseFileRaw(requestParameters: DeleteTermsOfUseFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['termsOfUseId'] == null) {
            throw new runtime.RequiredError(
                'termsOfUseId',
                'Required parameter "termsOfUseId" was null or undefined when calling deleteTermsOfUseFile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/TermsOfUse/{termsOfUseId}`;
        urlPath = urlPath.replace(`{${"termsOfUseId"}}`, encodeURIComponent(String(requestParameters['termsOfUseId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async deleteTermsOfUseFile(requestParameters: DeleteTermsOfUseFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.deleteTermsOfUseFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getNewestTermsOfUseRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TermsOfUseFileResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/TermsOfUse/Newest`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TermsOfUseFileResponseFromJSON(jsonValue));
    }

    /**
     */
    async getNewestTermsOfUse(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TermsOfUseFileResponse | null | undefined > {
        const response = await this.getNewestTermsOfUseRaw(initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     */
    async termsOfUseGetAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TermsOfUseResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/TermsOfUse/All`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TermsOfUseResponseFromJSON(jsonValue));
    }

    /**
     */
    async termsOfUseGetAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TermsOfUseResponse> {
        const response = await this.termsOfUseGetAllRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async termsOfUseGetByIdRaw(requestParameters: TermsOfUseGetByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TermsOfUseFileResponse>> {
        if (requestParameters['termsOfUseId'] == null) {
            throw new runtime.RequiredError(
                'termsOfUseId',
                'Required parameter "termsOfUseId" was null or undefined when calling termsOfUseGetById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/TermsOfUse/{termsOfUseId}`;
        urlPath = urlPath.replace(`{${"termsOfUseId"}}`, encodeURIComponent(String(requestParameters['termsOfUseId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TermsOfUseFileResponseFromJSON(jsonValue));
    }

    /**
     */
    async termsOfUseGetById(requestParameters: TermsOfUseGetByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TermsOfUseFileResponse | null | undefined > {
        const response = await this.termsOfUseGetByIdRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     */
    async uploadTermsOfUsePostRaw(requestParameters: UploadTermsOfUsePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['uploadedFile'] != null) {
            formParams.append('uploadedFile', requestParameters['uploadedFile'] as any);
        }


        let urlPath = `/api/TermsOfUse`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async uploadTermsOfUsePost(requestParameters: UploadTermsOfUsePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.uploadTermsOfUsePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
